import { IHttpClient } from '@micro-frontend-react/employee-experience/lib/IHttpClient';
import { put, getContext, all, takeLatest, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { IRequestViewsAction, ViewsActionType } from './Views.action-types';
import { receiveViews } from './Views.actions';

export function* fetchViews(action: IRequestViewsAction): SagaIterator {
  const { applicationId } = action;
  const httpClient: IHttpClient = yield getContext('httpClient');

  try {
    const { data } = yield call([httpClient, httpClient.request], {
      url: `${__API_BASE_URL__}/applications/${applicationId}/views`,
      resource: __API_RESOURCE__,
    });

    yield put(receiveViews(data));
  } catch {}
}

export function* viewsSagas(): SagaIterator {
  yield all([takeLatest(ViewsActionType.REQUEST_VIEWS, fetchViews)]);
}
